import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const ConnectTab = ({ updateChatTabData, chatTabData }) => {
    const [lineId, setLineId] = useState("");

    useEffect(() => {
        if (chatTabData?.line_id) {
            setLineId(chatTabData.line_id);
        }
    }, [chatTabData?.line_id]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setLineId(value);
        updateChatTabData("line_id", value);
    };

    return (
        <div className="whats-app-side-baar-connect-tab">
            <span>Connect</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        value={lineId}
                        onChange={handleInputChange}
                        placeholder="Line ID...."
                    />
                </div>
            </div>
            <Link to="https://developers.line.biz/en/docs/messaging-api/sharing-bot/#share-the-line-id-of-your-bot" target="_blank">How to find your Line ID</Link>
        </div>
    );
};

export default ConnectTab;